import React, {Component} from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel
} from "react-accessible-accordion";

class ParagraphSponsorsList extends Component {
  render() {
    return (
      <div className="container">
        <Accordion preExpanded={[0]}>
          {this.props.sponsors.map((item, index) => (
            <AccordionItem key={index} uuid={index} className={'my-1'}>
              <AccordionItemHeading>
                <AccordionItemButton>
                  {item.month}
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                {item.sponsors.map((sponsor) => (
                  <div>{sponsor.printFriendlyDate} – {sponsor.field_pate[0].value}</div>
                ))}
              </AccordionItemPanel>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    );
  }
}

export default ParagraphSponsorsList;
